module.exports = __webpack_public_path__ + "static/media/car-mileage-blue.fed4aa7e.svg";